// extracted by mini-css-extract-plugin
module.exports = {"container":"container-10RUa","thumb":"thumb-3NvYC","detailsContainer":"detailsContainer-1cng1","name":"name-CZ4e-","city":"city-1xBIh","thumbDetail":"thumbDetail-1GUBD"};